//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { loadTrackingService } from "../services";
import { TrackingContext } from "../context/TrackingContext";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerFilter() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { startDateFilter, setStartDateFilter } = useContext(TrackingContext); // Estado que armazena a Data informada pelo usuário no filtro 
    const { endDateFilter, setEndDateFilter } = useContext(TrackingContext);
    const { urlFilter, setUrlFilter } = useContext(TrackingContext);
    const { campaignFilter, setCampaignFilter } = useContext(TrackingContext);
    const { sourceFilter, setSourceFilter } = useContext(TrackingContext);
    const { groupProductsFilter, setGroupProductsFilter } = useContext(TrackingContext);
    const { groupProducts, setGroupProducts } = useContext(TrackingContext);
    const { events, setEvents } = useContext(TrackingContext); // Estado que armazena a lista de eventos existentes





    //--------------- USE EFFECT QUE OCORRE APÓS A ALTERAÇÃO NO FILTRO DATA ---------------//
    useEffect(() => {
        setEvents([])
        handleLoadEvents();
    }, [startDateFilter, endDateFilter, groupProductsFilter, urlFilter, campaignFilter, sourceFilter]);



    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR EVENTOS ---------------//
    // Responsável por requisitar à API os eventos existentes
    // Armazena no Estado "eventos" a lista de eventos retornada pela API
    async function handleLoadEvents() {
        const response = await loadTrackingService(startDateFilter, endDateFilter);
        if (response) {
            setEvents(response.data[0]);
        }
    };




    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* FILTRO DE DATA */}
            <div className="flex flex-wrap items-center gap-2 mb-8">

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className=" text-sm text-ink-3 mb-1">Filtrar por Data Inicial</label>
                    {/* INPUT DA DATA INICIAL */}
                    <input type="date" value={startDateFilter} onChange={e => setStartDateFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Data Final</label>
                    {/* INPUT DA DATA FINAL */}
                    <input type="date" value={endDateFilter} onChange={e => setEndDateFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por URL</label>
                    {/* INPUT DA DATA FINAL */}
                    <input type="text" value={urlFilter} onChange={e => setUrlFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

                {/* FILTRO POR GRUPO DE PRODUTOS  */}
                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar Grupo de Produtos</label>
                    <select
                        value={groupProductsFilter}
                        // onChange={(e) => {
                        //     const selectedValue = e.target.value;
                        //     setGroupProductsFilter(selectedValue === '' ? null : parseInt(selectedValue));
                        // }}
                        className="h-[40px] truncate bg-surface-2 border border-white/[0.12] px-4 py-2 rounded text-sm text-white focus:outline-none focus:ring-2 focus:ring-brand-500"
                    >
                        <option value={null}>Todos</option>
                        {groupProducts.map(group => (
                            <option key={group.id} value={group.id}>{group.nome}</option>
                        ))}
                    </select>
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Campanha</label>
                    {/* INPUT DA DATA FINAL */}
                    <input type="text" value={campaignFilter} onChange={e => setCampaignFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

                <div className="flex flex-col w-full sm:max-w-[250px]">
                    <label className="text-sm text-ink-3 mb-1">Filtrar por Source</label>
                    {/* INPUT DA DATA FINAL */}
                    <input type="text" value={sourceFilter} onChange={e => setSourceFilter(e.target.value)} className="h-[40px] bg-surface-2 p-2 rounded w-full" />
                </div>

            </div>

        </>
    )
}